module.exports = __webpack_public_path__ + "static/media/vicky.324624f9.jpeg";